<template>
  <speed-slider :label="$t('tts_speed')" :speed='speed' @speed-changed='handleSpeedChange' v-bind="$attrs"/>
</template>

<script>
import { inject, defineComponent } from 'vue';
import { useEvent } from '../../plugins/vue-gtag';
import SpeedSlider from './SpeedSlider.vue';
import { debounce } from '../../utils/events';

export default defineComponent({
  components: {
    SpeedSlider,
  },
  setup(_, context){
    const speed = inject('speed');
    const gaSpeedTts = debounce(useEvent('speed_tts'));

    const handleSpeedChange = (newVal)=>{
      localStorage.setItem("last_speed_selection", newVal);
      speed.value = newVal;
      gaSpeedTts(newVal);
      if (context.listeners['speed-changed'])
        context.listeners['speed-changed'].call(newVal);
    }
    
    return {
      speed,
      handleSpeedChange
    }
  }
})
</script>
